import styled from 'styled-components'

import { Section as GeneralSection } from 'components/general-styles/General'
import { theme } from 'styles/theme'

import { CARD_GAP, fluidType, fromMobileFrame } from '../fluid-type'

const { colors, media, space } = theme

export const Section = styled(GeneralSection)`
  background-color: ${colors['blue-background-strong-default']};
`

export const TitleWrapper = styled.div`
  h2,
  h2 span {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    letter-spacing: -0.02em;
  }
`

export const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${CARD_GAP};
  margin-top: ${space['spacing-xl']};

  @media (${media.desktop}) {
    grid-template-columns: repeat(4, 1fr);
    margin-top: 3.125rem;
  }
`

export const Card = styled.article`
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
  background-color: ${colors['neutral-background-contrast']};

  /* 20px do desenho: a escala de raio pula de 16px para 24px. */
  border-radius: 1.25rem;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    /* O enquadramento do desenho ancora no topo, preservando o rosto. */
    object-position: top;
  }

  @media (${media.phone}) {
    border-radius: ${fromMobileFrame(18)};
  }

  @media (${media.tablet}) {
    aspect-ratio: 328 / 350;
  }
`

export const Scrim = styled.div`
  position: absolute;
  inset: 0;
  background: linear-gradient(
    to bottom,
    rgb(0 40 75 / 0%) 45%,
    rgb(0 40 75 / 55%) 72%,
    rgb(0 40 75 / 92%) 100%
  );
`

export const Info = styled.div`
  position: absolute;
  right: ${space['spacing-md']};
  bottom: ${space['spacing-md']};
  left: ${space['spacing-md']};

  p {
    margin: 0;
    overflow-wrap: break-word;
    hyphens: auto;
  }

  /* 16px é o tamanho do cargo no desenho; o bodySmall de 18px alargava a
     linha e forçava mais uma quebra. */
  p:last-child {
    font-size: 1rem;
  }

  @media (${media.phone}) {
    right: ${fromMobileFrame(11)};
    bottom: ${fromMobileFrame(11)};
    left: ${fromMobileFrame(11)};

    p,
    p:last-child {
      font-size: ${fromMobileFrame(16)};
    }
  }
`
